import React from "react";
import "./App.css";
import Header from "./Header/Header";
import ExperienceItem from "./ExperienceItem/ExperienceItem";
import Education from "./Education/Education";
import ResumeJson from "./resume-v2.json";
import Objective from "./Objective/Objective";
import { DetailLevel, ResumeContext } from "./resume-context";

class App extends React.Component {
  setDetailLevel: (detailLevel: DetailLevel) => void;

  state: {
    detailLevel: DetailLevel;
    theme: string;
    myProp: string;
  } = {
    detailLevel: DetailLevel.medium,
    theme: "night-owl",
    myProp: "",
  };

  constructor(props: any) {
    super(props);

    this.setDetailLevel = (detailLevel: DetailLevel) => {
      this.setState((state) => ({
        detailLevel: detailLevel,
      }));
    };
  }

  Experience = ResumeJson.careerExperience;

  TechnicalProficiencies = [
    {
      category: "Languages",
      items: [
        "Python",
        "JavaScript/TypeScript",
        "Objective-C/Swift",
        "C/C++",
        "Kotlin",
        "Go",
        "Clojure",
      ],
    },
    {
      category: "Frameworks",
      items: [
        "UIKit",
        "React",
        "Ruby On Rails",
        "SwiftUI",
        "TailwindCSS",
        "PyQt/PySide",
      ],
    },
    {
      category: "Databases",
      items: [
        "Postgres",
        "SQLite",
        "Datomic",
        "MySQL",
        "SQL Server",
        "MongoDB",
      ],
    },
  ];

  render() {
    // const className = `App ${this.state.myProp}`;
    return (
      <>
        <div className="wrapper">
          <ResumeContext.Provider
            value={{ ...this.state, setDetailLevel: this.setDetailLevel }}
          >
            <div className="printPage">
              <Header></Header>

              <Objective></Objective>

              <section className="skills">
                <h1>Technical Proficiencies</h1>
                <dl>
                  {this.TechnicalProficiencies.map((proficiency) => (
                    <div key={proficiency.category}>
                      <dt>{proficiency.category}</dt>
                      <dd>
                        <ol>
                          {proficiency.items.map((item) => (
                            <li key={item}>{item}</li>
                          ))}
                        </ol>
                      </dd>
                    </div>
                  ))}
                </dl>
              </section>

              <section>
                <h1>Career Experience</h1>
                {this.Experience.map((experienceItem, index) => (
                  <ExperienceItem experienceItem={experienceItem} key={index} />
                ))}
              </section>

              <section>
                <h1>Early Career (2005-2011)</h1>
                <p>
                  Software Engineer at FactSet Research Systems
                  (Windows/MFC/.NET), Bloomberg LP (ADSK, Training/Development),
                  and Milestone Capital Management (Ruby on Rails). Financial
                  services and enterprise systems development.
                </p>
              </section>

              <section>
                <h1>Education</h1>
                <Education
                  schoolName="Villanova University"
                  schoolLocation="Villanova, PA"
                  graduation="Class of 2005"
                  degreeDescription="B.S. Computer Engineering, Minor Computer Science"
                  honors="Cum Laude"
                ></Education>
              </section>
            </div>
          </ResumeContext.Provider>
        </div>
      </>
    );
  }
}

export default App;
